import { render, staticRenderFns } from "./VehicleWidget.vue?vue&type=template&id=79bbcd09"
import script from "./VehicleWidget.vue?vue&type=script&lang=js"
export * from "./VehicleWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports